function InitilaizeStreetsResults() {
    $('.street-results-error').html('');
    InitializeValidators();
    $('#street-results-container :radio:first').prop('checked', true);
    $('.streets-results-add').click(function() {
        var selectedStreet = $('#street-results-container :radio:checked');
        $('#StreetSelected').val(selectedStreet.val() + ':' + selectedStreet.data('description'));

        $.DotComAjax({
            url: "/Home/Streets",
            cache: false,
            success: function (data) {
                if (data.IsSuccess) {
                    UpdateCountAndCriteria();
                } else {
                    $('.street-results-error').html(data.Message);
                }
            },
            async: false,
            type: 'post',
            data: $('#StreetsResultsControl').serialize()
        });
    });
}